import { Action } from '@reduxjs/toolkit'
import { Service } from '@repo/core'

export const createConfig = <Response, Params>(
  action: Action,
  service: Service<Response, Params>,
  requestAction: Action,
) => ({
  apiClientDomain: 'clientsStatics' as const,
  service,
  getError: (error: any) => error.response?.data || error.message,
  actionTypeResponse: action.type,
  actionTypeRequest: requestAction.type,
  getParams: (params: any) => params,
})
